import { State } from '../reducers/rootReducer'
import { FiltersState } from '../reducers/filtersReducer'

const filtersSelector = (state: State): FiltersState => state.filters

export default filtersSelector
